import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * LEGACY: Workflow ID for pickup operations.
 */
export const schema = z.number().int().positive();

export type PickupWorkflowId = z.infer<typeof schema>;

export const definition = define({
  key: 'pickup_workflow_id',
  schema,
  label: 'Pickup Workflow ID',
  description: 'LEGACY: Workflow ID for pickup operations. Defines driver steps during vehicle pickup.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.WORKFLOWS.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
  deprecated: true,
});
